module.exports = __webpack_public_path__ + "static/media/carbon.784472b5.svg";